import PageLayout from '../components/layout/PageLayout'
import SublocationsList from 'components/lists/sublocations/SublocationsList';

export default function SublocationsPage() {
  return (
    <PageLayout 
    pageTitle='Sub-ubicaciones' 
    pageDesc='Altas, bajas y modificaciones.'>
      <SublocationsList/>
    </PageLayout>
  )
}